import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class CartsApi extends Api {
  readonly url = "/v1/carts";

  constructor($axios: Context["$axios"]) {
    super("cartService", $axios);
  }

  async get({ includes }: GetManyCartsParams) {
    return await this.request<ManyCartsResponse>({
      method: "GET",
      params: {
        includes,
      },
    });
  }

  async getOne({ cartId, includes }: GetOneCartParams) {
    return await this.request<OneCartResponse>({
      method: "GET",
      url: `${this.url}/${cartId}`,
      params: {
        includes,
      },
    });
  }

  async delete({ ids }: DeleteCartParams) {
    return await this.request<void>({
      method: "DELETE",
      params: {
        ids,
      },
    });
  }
}
